import { ReactKeycloakProvider } from "@react-keycloak/web"

import { keycloakInstance } from "../../shared/libs/keycloack/config"
import { useAppDispatch } from "../../shared/libs/redux/useAppDispatch"
import { setToken } from "../../entities/user/model/user"

export const withKeycloak = (Component: React.ComponentType) => () => {
  const dispatch = useAppDispatch()
  return (
    <ReactKeycloakProvider
      initOptions={{
        onLoad: "login-required",
        flow: "standard",
      }}
      authClient={keycloakInstance}
      onTokens={(tokens) => dispatch(setToken(tokens.token))}
    >
      <Component />
    </ReactKeycloakProvider>
  )
}
